<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import * as packageJson from './package.json'
import { useRoute } from 'vue-router'
import { useVersionCheck } from '~/composables/useVersionCheck'

const route = useRoute();

const excludedPaths = [
  '/streaming',
  '/sharing'
];

if (!excludedPaths.includes(route.path)) {
  useVersionCheck();
}

const url = useRequestURL();

useNuxtUTM();

console.log(
  '%cFrontend Version: %c' + (packageJson?.version || 'unknown'),
  'color: #c41c87; font-size: 20px; font-weight: bold;',
  'color: #4CAF50; font-size: 20px; font-weight: bold;'
);

useHead({
  charset: 'utf-8',
  viewport: 'width=device-width, initial-scale=1.0 maximum-scale=1, user-scalable=no, viewport-fit=cover',
  meta: [
    { name: 'msapplication-TileColor', content: '#ffffff' },
    { name: 'msapplication-TileImage', content: '/ms-icon-144x144.png' },
    { name: 'theme-color', content: '#ffffff' }
  ],
  link: [
    { rel: 'apple-touch-icon', sizes: '57x57', href: '/apple-icon-57x57.png' },
    { rel: 'apple-touch-icon', sizes: '60x60', href: '/apple-icon-60x60.png' },
    { rel: 'apple-touch-icon', sizes: '72x72', href: '/apple-icon-72x72.png' },
    { rel: 'apple-touch-icon', sizes: '76x76', href: '/apple-icon-76x76.png' },
    { rel: 'apple-touch-icon', sizes: '114x114', href: '/apple-icon-114x114.png' },
    { rel: 'apple-touch-icon', sizes: '120x120', href: '/apple-icon-120x120.png' },
    { rel: 'apple-touch-icon', sizes: '144x144', href: '/apple-icon-144x144.png' },
    { rel: 'apple-touch-icon', sizes: '152x152', href: '/apple-icon-152x152.png' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-icon-180x180.png' },
    { rel: 'icon', type: 'image/png', sizes: '192x192', href: '/android-icon-192x192.png' },
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
    { rel: 'icon', type: 'image/png', sizes: '96x96', href: '/favicon-96x96.png' },
    { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
    { rel: 'manifest', href: '/manifest.json' },
    { rel: 'canonical', href: url.href }
  ],
  script: [
    {
      key: 'helpercenter',
      type: 'text/javascript',
      innerHTML: `<!-- HelpCenter.io smart widget code -->
  (function(){
    var s = document.createElement('script');
    s.src = "//helpcenter.io/js/init.js";
    s.async = true;
    window.hcOptions = {
        app_id: 's4gY2'
    };
    document.body.appendChild(s);
})();
<!-- End HelpCenter.io smart widget code -->`,
      tagPosition: 'bodyClose'
    }
  ]
  // FIXME: dynamic language value
  // htmlAttrs: {
  //   lang: 'en'
  // }
});

useSeoMeta({
  title: 'Aristeem',
  description: 'All programs in one place.',
  ogTitle: 'Aristeem',
  ogDescription: 'All must-have programs in one place',
  ogLocale: 'en_US',
  ogType: 'website',
  ogUrl: () => url.href,
  ogImage: 'https://beta.aristeem.com/ms-icon-310x310.png',
  ogSiteName: 'Aristeem',
  ogImageWidth: '310',
  ogImageHeight: '310',
  ogImageType: 'image/png',

  twitterCard: 'summary_large_image',
  twitterTitle: 'Aristeem',
  twitterDescription: 'All must-have programs in one place',
  twitterImage: 'https://beta.aristeem.com/ms-icon-310x310.png',
  twitterSite: '@aristeem',
  twitterCreator: '@aristeem'
});
</script>
